module.exports = __webpack_public_path__ + "static/media/confirm.4900efe3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/img/confirm.svg
// module id = 116
// module chunks = 0